import BaseUseCase from "../base_use_case.js";

class NewslettersSubscriptionUseCase extends BaseUseCase {

  execute(params, token) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/newsletters/subscriptions`,
      data: {
        subscription: params,
        recaptchaToken: token
      }
    });
  }
}

const instance = new NewslettersSubscriptionUseCase();
export default instance;